import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report, ReportUIRenderer } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import SuperSetCriteria from "../../../Domain/Models/SuperSet/SuperSetCriteria";
import { AppService, Types } from "../../../App/Services/AppService";
import { FileUtils } from "@singularsystems/neo-core";
import { Layout } from "@singularsystems/neo-canvas-grid";

@NeoReport("PowerPuff", { category: ReportCategory.SystemReports })
export default class PowerPuffReport extends Report<SuperSetCriteria> {

    constructor() {
        super(SuperSetCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.FormGroup bind={this.criteria.meta.endDate} />
            <Neo.FormGroup bind={this.criteria.meta.useNitAccountNumbers} label="Use NIT account numbers?" footerText="Whether 'Account Number' should be prefixed with NIT or DPA/DPL" />
        </div>;
    }

    get uiRenderer() {
        return PowerPuffReportUIRenderer;
    }

        public getDefaultGridLayout(criteria?: SuperSetCriteria | undefined, propertyKey?: string | undefined): Layout.IGridLayout | undefined {
        return {
            "root": {
                "headerLines": 2,
                "columns": [
                    {
                        "key": "investmentIdCombined",
                        "suppressTotal": true
                    },
                    {
                        "key": "investment",
                        "suppressTotal": true
                    },
                    {
                        "key": "investorInvestment",
                        "suppressTotal": true
                    },
                    {
                        "key": "pipelinePercent",
                        "suppressTotal": true
                    },
                    {
                        "key": "liquidityPremium",
                        "suppressTotal": true
                    },
                    {
                        "key": "ncc",
                        "suppressTotal": true
                    },
                    {
                        "key": "rateSpread",
                        "suppressTotal": true
                    },
                    {
                        "key": "rateRatio",
                        "suppressTotal": true
                    },
                    {
                        "key": "actualRate",
                        "suppressTotal": true
                    },
                    {
                        "key": "lastGivenDefault",
                        "suppressTotal": true
                    },
                    {
                        "key": "ftpCapacity",
                        "suppressTotal": true
                    },
                    {
                        "key": "ftpExternal",
                        "suppressTotal": true
                    },
                    {
                        "key": "externallyFunded",
                        "suppressTotal": true
                    },
                    {
                        "key": "capacityFunded",
                        "suppressTotal": true
                    },
                    {
                        "key": "wavFtpRate",
                        "suppressTotal": true
                    },
                    {
                        "key": "intraGroupType",
                        "suppressTotal": true
                    },
                    {
                        "key": "cognosWavFtp",
                        "suppressTotal": true
                    },
                    {
                        "key": "recoveryRate",
                        "suppressTotal": true
                    },
                    {
                        "key": "taxRate",
                        "suppressTotal": true
                    },
                    {
                        "key": "averagePrime",
                        "suppressTotal": true
                    },
                    {
                        "key": "primeRR",
                        "suppressTotal": true    
                    },
                    {
                        "key": "prodIdent",
                        "suppressTotal": true
                    }
                ]
            }
        } as Layout.IGridLayout;
    }
}

class PowerPuffReportUIRenderer extends ReportUIRenderer {

    renderActionButtons(): React.ReactNode {

        return <>
            {super.renderActionButtons()}
            <Neo.Button
                icon="file-archive"
                variant="secondary"
                onClick={() => this.downloadZipFile()}>
                Download Zip File
            </Neo.Button>
        </>
    }

    private async downloadZipFile() {
        const apiClient = AppService.get(Types.Domain.ApiClients.ExportApiClient);

        const response = await this.props.taskRunner.waitFor(apiClient.getPowerPuffZipFile((this.report as PowerPuffReport).criteria.toJSObject()), { allowPost: true });

        FileUtils.showSaveFile(response);
    }
}